import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"8","sm":"10"}},[_c(VRadioGroup,{attrs:{"hint":`${_vm.facilityType}`,"dense":"","label":"Pool Type","row":""},model:{value:(_vm.facilityType),callback:function ($$v) {_vm.facilityType=$$v},expression:"facilityType"}},[_c(VRadio,{attrs:{"label":"25m","value":"25m"}}),_c(VRadio,{attrs:{"label":"50m","value":"50m"}}),_c(VRadio,{attrs:{"label":"25y","value":"25y"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }